export function isValidRUT(value) {
  return /^\d{4,9}-?[A-Za-z0-9]$/.test(value)
}
